import * as d3 from 'd3';

import {Dims, Margin} from 'src/lib/commonTypes';
import {getGraphDims} from 'src/lib/vizUtils';

import Axis, {XScale, formatDateTick, getDateTickOptions, getDateTicks} from './D3Axis';
import {NowLine} from './NowLine';

type Props = {
  x: XScale;
  timeZone: string;
  dateRange: [Date, Date];
  dims: Dims;
  margin: Margin;
  tickFormat?: (date: Date, timeZone: string) => string;
};

export default function TimeSeriesXAxis({
  x,
  timeZone,
  dateRange,
  dims,
  margin,
  tickFormat,
}: Props) {
  const graphDims = getGraphDims(dims, margin);

  return (
    <svg width={dims[0]} height={dims[1]} className="pointer-events-none absolute top-0">
      <g transform={`translate(${margin.left}, ${margin.top})`}>
        <NowLine x={x} dateRange={dateRange} graphDims={graphDims} />
      </g>
      {/* X-Axis */}
      <g transform={`translate(${margin.left}, ${graphDims[1] + margin.top})`}>
        <Axis
          axisCreator={d3
            .axisBottom(x)
            .tickValues(getDateTicks(dateRange[0], dateRange[1], timeZone, dims[0]))
            .tickFormat((date) =>
              tickFormat
                ? tickFormat(date as Date, timeZone)
                : formatDateTick(
                    date as Date,
                    getDateTickOptions(dateRange[0], dateRange[1], dims[0]).dateTimeUnit,
                    timeZone
                  )
            )}
        />
      </g>
    </svg>
  );
}
